import React from "react";
import styled from 'styled-components'
const CheckboxWrap = styled.div`
  cursor: pointer;
  position: relative;
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 1px;
    width: 1px;
  }
  label {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .checkmark {
    display: block;
    width: 24px;
    height: 24px;
    border: 2px solid var(--bs-forest-green);
    background-color: var(--bs-lime-green);
    transition: background-color 0.3s ease;
  }
  &:hover input ~ .checkmark {
    background-color: var(--bs-forest-green);
  }
  input:checked ~ .checkmark {
    background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.20191 9.82505L4.02575 9.64889L3.84898 9.82442L2.66565 10.9994L2.48762 11.1762L2.66502 11.3536L7.32335 16.0119L7.50013 16.1887L7.67691 16.0119L17.6769 6.01193L17.8537 5.83516L17.6769 5.65838L16.5019 4.48338L16.3252 4.30669L16.1484 4.4833L7.50021 13.1234L4.20191 9.82505Z' fill='%23C0EF92' stroke='%23C0EF92' stroke-width='0.5'/%3E%3C/svg%3E%0A");
    background-color: var(--bs-forest-green);
  }
`;

const CheckboxText = styled.span`
  a {
    color: var(--bs-forest-green);
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }
`;
export const InputCheckbox = ({title, onChange, className = '', ...other}) => {
  const toggleCheckbox = (e) => {
    onChange(e.target.checked);
  }
  return title && (
    <CheckboxWrap className={className}>
      <label>
        <input type="checkbox" {...other} onChange={toggleCheckbox}/>
        <span className="checkmark"></span>
        <CheckboxText dangerouslySetInnerHTML={{__html: title}}/>
      </label>
    </CheckboxWrap>
  )
}
